/**
 * AssessmentChoice scene slice
 *
 * @author Carlos Silva <csilva@ubiwhere.com>
 *
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export default createSlice({
  name: 'AssessmentChoice',
  initialState,
  reducers: {
    onMount: () => {},
    onUnmount: () => {},
  },
});
